import { makeStyles } from '@ellucian/react-design-system/core';
import { spacing80, fontWeightBold } from '@ellucian/react-design-system/core/styles/tokens';
import { Divider } from '@ellucian/react-design-system/core';
const useStyles = makeStyles({
    name: 'SectionLabel'
})(() => ({
    divider: {
        width: spacing80,
    },
    root: {
        fontWeight: fontWeightBold,
    },
}));
const SectionLabel = props => {
    const { classes } = useStyles();
    const { children = null } = props;
    return (
        <div className={classes.root}>
            {children}
            <Divider classes={{ root: classes.divider }} />
        </div>
    );
};
export default SectionLabel;
